import React from 'react'
import PropTypes from 'prop-types'

import { get, find } from 'lodash'

import { Box, Button, Collapse } from '@material-ui/core'

import { format } from 'date-fns'

import BoundedDateRange from './BoundedDateRange'

import options from './ranges'
class VisitRangeMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      potentialSelection: find(options, { value: props.rangeType }),
    }
    if (get(this.state.potentialSelection, 'value') === 'custom') {
      this.state.fromDate = props.range.from
      this.state.toDate = props.range.to
    }
  }
  clear() {
    this.setState({
      potentialSelection: undefined,
      fromDate: undefined,
      toDate: undefined,
    })
    this.props.onRangeClear()
  }
  rangeChange() {
    let { fromDate, toDate } = this.state
    const { potentialSelection } = this.state
    if (potentialSelection.generateRange) {
      const newRange = potentialSelection.generateRange()
      fromDate = newRange.fromDate
      toDate = newRange.toDate
    }
    this.props.onRangeChange(fromDate, toDate, potentialSelection.value)
  }
  isApplyDisabled() {
    const { potentialSelection, fromDate, toDate } = this.state
    return !potentialSelection || (potentialSelection.value === 'custom' && (!fromDate || !toDate))
  }
  render() {
    return (
      <Box padding={2}>
        <Box
          display="flex"
          flexDirection="column"
          gridGap={8}
          mb={2}
        >
          {options.map((item) => {
            return (
              <Button
                key={item.value}
                fullWidth
                color="primary"
                variant={this.state.potentialSelection === item ? 'contained' : 'outlined'}
                onClick={() => this.setState({ potentialSelection: item })}
              >
                {item.label}
              </Button>
            )
          })}
        </Box>
        <Collapse in={get(this.state, 'potentialSelection.value') === 'custom'}>
          <Box mb={2}>
            <BoundedDateRange
              id="date-range-selector"
              from={this.state.fromDate}
              to={this.state.toDate}
              onUpdate={(from, to) => {
                const fmtFrom = from === undefined ? from : format(new Date(from), 'yyyy-MM-dd')
                const fmtTo = to === undefined ? to : format(new Date(to), 'yyyy-MM-dd')
                this.setState({ fromDate: fmtFrom, toDate: fmtTo })
              }}
            />
          </Box>
        </Collapse>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gridGap={8}
          borderTop={1}
          borderColor="divider"
          pt={2}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => this.clear()}
          >
            Clear
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={this.isApplyDisabled()}
            onClick={() => this.rangeChange()}
          >
            Apply
          </Button>
        </Box>
      </Box>
    )
  }
}

VisitRangeMenu.propTypes = {
  onRangeChange: PropTypes.func.isRequired,
  onRangeClear: PropTypes.func.isRequired,
  range: PropTypes.shape({
    from: PropTypes.object,
    to: PropTypes.object,
  }),
  rangeType: PropTypes.oneOf(options.map((option) => option.value)),
}

export default VisitRangeMenu
